import {  useEffect,useState } from "react";
import { flushSync } from "react-dom";
import "./faq.scss";
import {  MotifAccordion, MotifAccordionContent, MotifAccordionTrigger, MotifProgressLoader } from "@ey-xd/motif-react";
import MotifSearch from "@ey-xd/motif-react/Search";
import { apiQueryWithToken} from "../../common/services/apiBaseUrlConfig";
import { useNavigate } from "react-router-dom";
import logger from "../../common/utils/logger";

export default function FAQ() {

      const [FAQList, setFAQList] = useState([]);
      const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [listKey, setListKey] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    fetchFAQList();
  }, []);
  const fetchFAQList = async () => {
    setIsLoading(true);
    await apiQueryWithToken.get('/api/Support/faqs')
      .then((data) => {
        logger.info("FAQ data", data);
        setFAQList(data?.data);
      })
      .catch((error) => {
        logger.error("An error occurred:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <div className="faq-container">
      <div className="faq-breadcrumbs">
        <span
          className="crumb-link"
          role="link"
          tabIndex={0}
          onClick={() => navigate('/help')}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate('/gethelp'); }}
        >
          Get help
        </span>
        <span className="crumb-sep">&nbsp;&gt;&nbsp;</span>
        <span className="crumb-current">FAQs</span>
      </div>
      <div className="faq-breadcrumb-divider" aria-hidden="true" />
      <div className="faq-header">
        <h1>Frequently asked questions (FAQ)</h1>
        <span>These are the most commonly asked questions about DBS.</span>
        <br />
        <span>Can't find what you're looking for? Contact us :  <a href="mailto:DBS@parthenon.ey.com">DBS@parthenon.ey.com</a></span>
      </div>
      <div className="faq-Section">
        {/* Search aligned to accordion start and width */}
        <div className="faq-list" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div style={{ width: '100%' }}>
            <div className="motif-search-input-wrapper" style={{ position: 'relative', width: '100%' }}>
              <MotifSearch
                aria-label="Search FAQs"
                placeholder="Search FAQs"
                value={searchTerm}
                onChange={(e) => {
                  const val = e.target?.value || "";
                  // Close any open accordions immediately when starting to type
                  if (!searchTerm && val.trim().length > 0) {
                    flushSync(() => {
                      setListKey((k) => k + 1);
                    });
                  }
                  setSearchTerm(val);
                }}
                style={{ height: '40px' }}
              />
            </div>
          </div>
       {isLoading ? (
         <div style={{ padding: "20px", textAlign: "center" }}>
           <MotifProgressLoader show variant="default" />
         </div>
       ) : (
        <div key={listKey}>
  {(() => {
    const normalized = (searchTerm || '').toLowerCase();
    const filteredFAQs = (FAQList || []).filter(item => (item?.question || '').toLowerCase().includes(normalized));
    if (filteredFAQs.length === 0) {
      return (
        <div style={{ padding: '12px 0', color: '#555' }}>
          <p>No FAQs match your search.</p>
          <p>Try checking spelling or different keywords.</p>
        </div>
      );
    }
    return filteredFAQs.map((faqItem, index) => (
      <MotifAccordion key={`${index}-${searchTerm}`} alignIconRight>
        <MotifAccordionTrigger
          icons={{
            collapseTitle: 'Collapse section',
            expandTitle: 'Expand section'
          }}
        >
          {faqItem.question}
        </MotifAccordionTrigger>
        <MotifAccordionContent>
          <p className="faq-answer">{faqItem.answer}</p>
        </MotifAccordionContent>
      </MotifAccordion>
    ));
  })()}
          </div>
       )}
        </div>
      </div>
        <div className="help-footer">
        <div><div className="title">Support</div>
        <span className="desc">
          If you have any feedback, issues or ideas for improving DBS, drop your
          feedback by contact us option.
        </span>
        </div>
        <div className="left-footer">
        <div className="prv-title">Privacy Statement</div>
        <span className="desc">
        <p style={{lineHeight:1.1}}>  © 2025 EYGM Limited | All Rights Reserved. Content within this
          application is confidential and meant for EY staff and EY clients only.</p>
        </span>
        </div>
      </div>
    </div>

  )
}